export default __webpack_public_path__ + "static/media/airlockz-blk-banner-2.a0904cc6.jpg";